import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-mongo-assortment-management-modal',
    templateUrl: './mongo-assortment-management-modal.component.html',
    styleUrls: ['./mongo-assortment-management-modal.component.css'],
    standalone: false
})
export class MongoAssortmentManagementModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
